const lang = {
  active_employees: {
    en: 'Active Employees',
    sp: 'Empleados activos'
  },
  language: {
    en: 'Language',
    sp: 'Idioma'
  },
  english: {
    en: 'English',
    sp: 'inglés'
  },
  spanish: {
    en: 'Spanish',
    sp: 'Español'
  },
  employee_merger: {
    en: 'Employee Merger',
    sp: 'Fusión de empleados'
  },
  configuration: {
    en: 'Configuration',
    sp: 'Configuración'
  },
  my_profile: {
    en: 'My Profile',
    sp: 'Mi perfil'
  },
  welcome: {
    en: 'Welcome',
    sp: 'Bienvenidos'
  },
  jobs_events: {
    en: 'Jobs/Events',
    sp: 'Trabajos/Eventos'
  },
  schedule: {
    en: 'Schedule',
    sp: 'Horario'
  },
  calendar: {
    en: 'Calendar',
    sp: 'Calendario'
  },
  resume: {
    en: 'Resume',
    sp: 'Currículum'
  },
  employers: {
    en: 'Employers',
    sp: 'Empleadores'
  },
  payroll: {
    en: 'Payroll',
    sp: 'Nómina'
  },
  venue: {
    en: 'Venue',
    sp: 'Lugar'
  },
  employees: {
    en: 'Employees',
    sp: 'Empleados'
  },
  daily_schedule: {
    en: 'Daily schedule',
    sp: 'Horario diario'
  },
  skills: {
    en: 'Skills',
    sp: 'Habilidades'
  },
  files: {
    en: 'Files',
    sp: 'Archivos'
  },
  report: {
    en: 'Report',
    sp: 'Reporte'
  },
  notify: {
    en: 'Notify',
    sp: 'Notificar'
  },
  support: {
    en: 'Support',
    sp: 'Apoyo'
  },
  status: {
    en: 'Status',
    sp: 'Estado'
  },
  group_users: {
    en: 'Group Users',
    sp: 'Usuarios de grupo'
  },
  get_new_password: {
    en: 'GET NEW PASSWORD?',
    sp: 'OBTENER NUEVA CONTRASEÑA?'
  },
  email: {
    en: 'E-MAIL',
    sp: 'EMAIL'
  },
  password: {
    en: 'PASSWORD',
    sp: 'CONTRASEÑA'
  },
  login: {
    en: 'Login',
    sp: 'Login'
  },
  enter_your_email: {
    en: 'Enter your email',
    sp: 'Introduce tu correo electrónico'
  },
  enter_your_password: {
    en: 'Enter your password',
    sp: 'Ingresa tu contraseña'
  },
  type_your_email: {
    en: 'Type your email',
    sp: 'Escriba su correo electrónico'
  },
  get_reset_link: {
    en: 'Get Reset Link',
    sp: 'Obtener enlace de restablecimiento'
  },
  thank_you: {
    en: 'Thank you',
    sp: 'Gracias'
  },
  reset_link_email_message: {
    en: 'Your reset link has been sent to your registerd email address',
    sp: 'Su enlace de restablecimiento ha sido enviado a su dirección de correo electrónico registrada'
  },
  login_page_change_password_note: {
    en: 'After logging in for the first time, please change your password, and user name if desired. Verify all personal information, and assign your skills',
    sp: 'Después de iniciar sesión por primera vez, cambie su contraseña y nombre de usuario si lo desea. Verifique toda la información personal y asigne sus habilidades'
  },
  privacy_policy: {
    en: 'Privacy policy',
    sp: 'Política de privacidad'
  },
  go_to_login: {
    en: 'Go To Login',
    sp: 'Ir a iniciar sesión'
  },

  memo_note_on_load: {
    en: 'Please Stand By While We Make Some Updates for you.',
    sp: 'Por favor, stand by mientras hacemos algunas actualizaciones para usted.'
  }

}

export default lang;